/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast.
*/


(function() {
  // Add custom code below this line


  /*
  ============================================================
  KLAVIYO HEADER TRIGGER
  ============================================================
  */

  const headerKlaviyoCustomTrigger = document.querySelector(
    'a[href="#welcome-discount"]'
  );

  if (headerKlaviyoCustomTrigger) {
    headerKlaviyoCustomTrigger.addEventListener('click', function(event) {
      window._klOnsite = window._klOnsite || [];

      window._klOnsite.push([
        'openForm',
        'VcBTf4'
      ]);
    });
  }


  /*
  ============================================================
  PRODUCT CARDS / SWATCHES / QUICK SIZE ATC
  ============================================================
  */

  (function() {


    /*
    ============================================================
    MOBILE PRODUCT CARD CAROUSEL
    ============================================================
    */

    function initMobileCardCarousels(root) {
      const carousels = (root || document).querySelectorAll(
        '[data-mobile-card-carousel]'
      );

      carousels.forEach((carousel) => {
        if (carousel.dataset.initialized === 'true') {
          return;
        }

        carousel.dataset.initialized = 'true';

        const track = carousel.querySelector(
          '[data-mobile-card-carousel-track]'
        );

        const dots = Array.from(
          carousel.querySelectorAll(
            '[data-mobile-card-carousel-dot]'
          )
        );

        const slides = Array.from(
          carousel.querySelectorAll(
            '.product-item__mobile-carousel-slide'
          )
        );

        if (
          !track ||
          !dots.length ||
          !slides.length
        ) {
          return;
        }


        let currentIndex = Number(
          carousel.dataset.currentIndex || 0
        );

        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let startTranslate = 0;

        let isDragging = false;
        let hasMoved = false;

        let pointerId = null;


        function getWidth() {
          return (
            carousel.offsetWidth ||
            carousel.clientWidth ||
            1
          );
        }


        function clampIndex(index) {
          return Math.max(
            0,
            Math.min(
              index,
              slides.length - 1
            )
          );
        }


        function updateDots(index) {
          dots.forEach((dot, dotIndex) => {
            dot.classList.toggle(
              'is-active',
              dotIndex === index
            );
          });
        }


        function setTranslate(valuePx, animate) {
          if (animate) {
            carousel.classList.remove(
              'is-dragging'
            );
          } else {
            carousel.classList.add(
              'is-dragging'
            );
          }

          track.style.transform =
            `translate3d(${valuePx}px, 0, 0)`;
        }


        function goToSlide(index, animate) {
          currentIndex = clampIndex(index);

          carousel.dataset.currentIndex =
            String(currentIndex);

          const width = getWidth();

          setTranslate(
            -currentIndex * width,
            animate !== false
          );

          updateDots(currentIndex);
        }


        function startDrag(event) {
          if (
            event.pointerType === 'mouse' &&
            event.button !== 0
          ) {
            return;
          }

          pointerId = event.pointerId;

          startX = event.clientX;
          startY = event.clientY;
          currentX = event.clientX;

          startTranslate =
            -currentIndex * getWidth();

          isDragging = true;
          hasMoved = false;

          carousel.dataset.wasDragged =
            'false';

          carousel.classList.add(
            'is-dragging'
          );

          if (
            carousel.setPointerCapture &&
            pointerId !== null
          ) {
            carousel.setPointerCapture(
              pointerId
            );
          }

          event.stopPropagation();
        }


        function moveDrag(event) {
          if (!isDragging) {
            return;
          }

          if (
            pointerId !== null &&
            event.pointerId !== pointerId
          ) {
            return;
          }

          currentX = event.clientX;

          const diffX =
            currentX - startX;

          const diffY =
            event.clientY - startY;

          const absX =
            Math.abs(diffX);

          const absY =
            Math.abs(diffY);


          if (
            absX > 5 &&
            absX > absY
          ) {
            hasMoved = true;

            carousel.dataset.wasDragged =
              'true';

            let nextTranslate =
              startTranslate + diffX;

            const maxTranslate = 0;

            const minTranslate =
              -(slides.length - 1) *
              getWidth();


            if (
              nextTranslate >
              maxTranslate
            ) {
              nextTranslate =
                maxTranslate +
                (
                  nextTranslate -
                  maxTranslate
                ) * 0.25;
            }


            if (
              nextTranslate <
              minTranslate
            ) {
              nextTranslate =
                minTranslate +
                (
                  nextTranslate -
                  minTranslate
                ) * 0.25;
            }


            setTranslate(
              nextTranslate,
              false
            );

            event.preventDefault();
            event.stopPropagation();
          }
        }


        function endDrag(event) {
          if (!isDragging) {
            return;
          }

          const diffX =
            currentX - startX;

          const width =
            getWidth();

          const threshold =
            Math.min(
              width * 0.2,
              70
            );

          let nextIndex =
            currentIndex;


          if (
            Math.abs(diffX) >
            threshold
          ) {
            nextIndex =
              diffX < 0
                ? currentIndex + 1
                : currentIndex - 1;
          }


          isDragging = false;
          pointerId = null;

          carousel.classList.remove(
            'is-dragging'
          );

          goToSlide(
            nextIndex,
            true
          );


          if (hasMoved) {
            carousel.dataset.wasDragged =
              'true';

            window.setTimeout(() => {
              carousel.dataset.wasDragged =
                'false';

              hasMoved = false;
            }, 220);
          }


          if (event) {
            event.stopPropagation();
          }
        }


        carousel.addEventListener(
          'pointerdown',
          startDrag
        );

        carousel.addEventListener(
          'pointermove',
          moveDrag
        );

        carousel.addEventListener(
          'pointerup',
          endDrag
        );

        carousel.addEventListener(
          'pointercancel',
          endDrag
        );

        carousel.addEventListener(
          'mouseleave',
          endDrag
        );


        const link =
          carousel.closest('a');


        if (
          link &&
          link.dataset.mobileCarouselClickBound !==
            'true'
        ) {
          link.dataset.mobileCarouselClickBound =
            'true';


          link.addEventListener(
            'click',
            (event) => {
              const activeCarousel =
                link.querySelector(
                  '[data-mobile-card-carousel]'
                );


              if (
                activeCarousel &&
                activeCarousel.dataset.wasDragged ===
                  'true'
              ) {
                event.preventDefault();
                event.stopPropagation();

                activeCarousel.dataset.wasDragged =
                  'false';
              }
            },
            true
          );
        }


        window.addEventListener(
          'resize',
          () => {
            goToSlide(
              currentIndex,
              false
            );
          }
        );


        goToSlide(
          currentIndex,
          false
        );
      });
    }



    /*
    ============================================================
    LINKED SWATCHES
    ============================================================
    */

    function normalizeLinkedSwatches(card) {
      if (!card) {
        return;
      }

      card.querySelectorAll(
        '[data-carousel-linked-swatch]'
      ).forEach((item) => {
        item.removeAttribute('hidden');

        item.classList.remove(
          'hidden'
        );

        item.style.setProperty(
          'display',
          'inline-flex',
          'important'
        );

        item.style.setProperty(
          'opacity',
          '1',
          'important'
        );

        item.style.setProperty(
          'visibility',
          'visible',
          'important'
        );
      });
    }


    function getLinkedCardData(
      card,
      handle
    ) {
      const templates =
        Array.from(
          card.querySelectorAll(
            '[data-carousel-linked-card-data]'
          )
        );


      return templates.find(
        (template) => {
          return (
            template.dataset.productHandle ===
            handle
          );
        }
      );
    }


    function updateCardFromLinkedSwatch(
      swatch
    ) {
      const card =
        swatch.closest(
          '[data-grid-item]'
        );

      if (!card) {
        return;
      }


      const title =
        swatch.dataset.productTitle;

      const url =
        swatch.dataset.productUrl;

      const handle =
        swatch.dataset.productHandle;

      const productId =
        swatch.dataset.productId;

      const variantId =
        swatch.dataset.variantId;

      const cutline =
        swatch.dataset.productCutline;


      normalizeLinkedSwatches(card);


      const cardDataTemplate =
        getLinkedCardData(
          card,
          handle
        );


      const cardDataSource =
        cardDataTemplate
          ? cardDataTemplate.content
          : swatch;


      const priceTemplate =
        cardDataSource.querySelector(
          '[data-carousel-linked-price-template]'
        );


      const featuredTemplate =
        cardDataSource.querySelector(
          '[data-carousel-linked-featured-template]'
        );


      const carouselTemplate =
        cardDataSource.querySelector(
          '[data-carousel-linked-carousel-template]'
        );


      const atcTemplate =
        cardDataSource.querySelector(
          '[data-carousel-linked-atc-template]'
        );


      card.querySelectorAll(
        '[data-carousel-linked-swatch]'
      ).forEach((item) => {
        const isActive =
          item === swatch;


        item.removeAttribute(
          'hidden'
        );

        item.classList.remove(
          'hidden'
        );


        item.style.setProperty(
          'display',
          'inline-flex',
          'important'
        );

        item.style.setProperty(
          'opacity',
          '1',
          'important'
        );

        item.style.setProperty(
          'visibility',
          'visible',
          'important'
        );


        item.classList.toggle(
          'is-active',
          isActive
        );


        item.setAttribute(
          'aria-pressed',
          isActive
            ? 'true'
            : 'false'
        );


        const siblingLink =
          item.querySelector(
            '.sibling__link'
          );


        if (siblingLink) {
          siblingLink.classList.remove(
            'sibling__link--current'
          );
        }
      });


      card.querySelectorAll(
        '[data-product-link]'
      ).forEach((link) => {
        if (url) {
          link.setAttribute(
            'href',
            url
          );

          link.setAttribute(
            'data-product-link',
            url
          );
        }


        if (title) {
          link.setAttribute(
            'aria-label',
            title
          );
        }
      });


      const titleEl =
        card.querySelector(
          '[data-product-card-title]'
        );


      if (
        titleEl &&
        title
      ) {
        titleEl.textContent =
          title;
      }


      const cutlineEl =
        card.querySelector(
          '[data-product-cutline]'
        );


      if (cutlineEl) {
        if (cutline) {
          cutlineEl.textContent =
            cutline;

          cutlineEl.style.display =
            '';
        } else {
          cutlineEl.textContent =
            '';

          cutlineEl.style.display =
            'none';
        }
      }


      const priceEl =
        card.querySelector(
          '[data-product-price]'
        );


      if (
        priceEl &&
        priceTemplate
      ) {
        priceEl.innerHTML =
          priceTemplate.innerHTML.trim();
      }


      const defaultImage =
        card.querySelector(
          '[data-product-image-default]'
        );


      if (
        defaultImage &&
        featuredTemplate
      ) {
        defaultImage.innerHTML =
          featuredTemplate.innerHTML.trim();
      }


      const mobileCarousel =
        card.querySelector(
          '[data-mobile-card-carousel]'
        );


      if (
        mobileCarousel &&
        carouselTemplate
      ) {
        mobileCarousel.innerHTML =
          carouselTemplate.innerHTML.trim();


        mobileCarousel.dataset.wasDragged =
          'false';

        mobileCarousel.dataset.currentIndex =
          '0';


        const newTrack =
          mobileCarousel.querySelector(
            '[data-mobile-card-carousel-track]'
          );


        if (newTrack) {
          newTrack.style.transform =
            'translate3d(0, 0, 0)';
        }


        delete mobileCarousel.dataset.initialized;


        initMobileCardCarousels(
          card
        );
      }


      const oldStyledAtc =
        card.querySelector(
          '[data-new-styled-atc]'
        );


      if (
        oldStyledAtc &&
        atcTemplate
      ) {
        oldStyledAtc.outerHTML =
          atcTemplate.innerHTML.trim();
      }


      const variantInput =
        card.querySelector(
          'input[name="id"]'
        );


      if (
        variantInput &&
        variantId
      ) {
        variantInput.value =
          variantId;
      }


      const quickAddHolder =
        card.querySelector(
          '[data-quick-add-holder]'
        );


      if (
        quickAddHolder &&
        productId
      ) {
        quickAddHolder.setAttribute(
          'data-quick-add-holder',
          productId
        );
      }


      const quickAddModalButton =
        card.querySelector(
          '[data-quick-add-modal-handle]'
        );


      if (
        quickAddModalButton &&
        handle
      ) {
        quickAddModalButton.setAttribute(
          'data-quick-add-modal-handle',
          handle
        );
      }


      window.requestAnimationFrame(
        () => {
          normalizeLinkedSwatches(
            card
          );
        }
      );


      window.setTimeout(
        () => {
          normalizeLinkedSwatches(
            card
          );
        },
        150
      );


      window.setTimeout(
        () => {
          normalizeLinkedSwatches(
            card
          );
        },
        500
      );
    }



    function initCarouselLinkedSwatches(
      root
    ) {
      const scope =
        root || document;


      scope.querySelectorAll(
        '[data-grid-item]'
      ).forEach(
        normalizeLinkedSwatches
      );


      window.setTimeout(
        () => {
          scope.querySelectorAll(
            '[data-grid-item]'
          ).forEach(
            normalizeLinkedSwatches
          );
        },
        300
      );


      window.setTimeout(
        () => {
          scope.querySelectorAll(
            '[data-grid-item]'
          ).forEach(
            normalizeLinkedSwatches
          );
        },
        1000
      );


      if (
        document.documentElement.dataset.carouselLinkedSwatchesBound ===
        'true'
      ) {
        return;
      }


      document.documentElement.dataset.carouselLinkedSwatchesBound =
        'true';


      document.addEventListener(
        'click',
        function(event) {
          const swatch =
            event.target.closest(
              '[data-carousel-linked-swatch]'
            );


          if (!swatch) {
            document.querySelectorAll(
              '[data-grid-item]'
            ).forEach(
              normalizeLinkedSwatches
            );

            return;
          }


          const card =
            swatch.closest(
              '[data-grid-item]'
            );


          if (card) {
            normalizeLinkedSwatches(
              card
            );
          }


          event.preventDefault();
          event.stopPropagation();


          if (
            event.stopImmediatePropagation
          ) {
            event.stopImmediatePropagation();
          }


          updateCardFromLinkedSwatch(
            swatch
          );
        },
        true
      );


      document.addEventListener(
        'keydown',
        function(event) {
          const swatch =
            event.target.closest(
              '[data-carousel-linked-swatch]'
            );


          if (!swatch) {
            return;
          }


          if (
            event.key === 'Enter' ||
            event.key === ' '
          ) {
            const card =
              swatch.closest(
                '[data-grid-item]'
              );


            if (card) {
              normalizeLinkedSwatches(
                card
              );
            }


            event.preventDefault();
            event.stopPropagation();


            if (
              event.stopImmediatePropagation
            ) {
              event.stopImmediatePropagation();
            }


            updateCardFromLinkedSwatch(
              swatch
            );
          }
        },
        true
      );
    }



    /*
    ============================================================
    CART HELPERS
    ============================================================
    */

    function getCartDrawerSectionId() {
      const section =
        document.querySelector(
          '[data-section-type="cart-drawer"][data-section-id]'
        );


      return section
        ? section.getAttribute(
            'data-section-id'
          )
        : null;
    }



    function escapeHTML(value) {
      return String(
        value || ''
      )
        .replace(
          /&/g,
          '&amp;'
        )
        .replace(
          /</g,
          '&lt;'
        )
        .replace(
          />/g,
          '&gt;'
        )
        .replace(
          /"/g,
          '&quot;'
        )
        .replace(
          /'/g,
          '&#039;'
        );
    }



    function formatCartMoney(
      cents,
      cart
    ) {
      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney ===
          'function'
      ) {
        const moneyFormat =
          window.theme?.moneyFormat ||
          window.theme?.settings?.moneyFormat ||
          window.moneyFormat ||
          '${{amount}}';


        return window.Shopify.formatMoney(
          cents,
          moneyFormat
        );
      }


      try {
        return new Intl.NumberFormat(
          document.documentElement.lang ||
            'en',
          {
            style: 'currency',

            currency:
              cart?.currency ||
              'USD'
          }
        ).format(
          (
            Number(cents) ||
            0
          ) / 100
        );
      } catch (error) {
        return (
          (
            Number(cents) ||
            0
          ) / 100
        ).toFixed(2);
      }
    }



    function updateCartCounts(cart) {
      if (
        !cart ||
        typeof cart.item_count ===
          'undefined'
      ) {
        return;
      }


      document.querySelectorAll(
        '[data-cart-count], cart-count'
      ).forEach((countEl) => {
        countEl.textContent =
          cart.item_count;


        countEl.setAttribute(
          'data-cart-count',
          cart.item_count
        );
      });
    }



    function revealCartDrawerAnimations() {
      const drawer =
        document.querySelector(
          'cart-drawer#cart-drawer'
        );


      if (!drawer) {
        return;
      }


      drawer.querySelectorAll(
        '[data-animation="cart-items-fade"], [data-animation="drawer-items-fade"]'
      ).forEach((item) => {
        item.classList.remove(
          'is-hiding'
        );


        item.classList.add(
          'is-animated',
          'aos-animate'
        );


        item.style.opacity =
          '1';


        item.style.animation =
          'none';
      });
    }



    /*
    ============================================================
    FREE SHIPPING BAR
    ============================================================
    */

    function updateFreeShippingBar(
      cart
    ) {
      if (!cart) {
        return;
      }


      document.querySelectorAll(
        '[data-free-shipping]'
      ).forEach(
        (shippingBar) => {
          const limit =
            Number(
              shippingBar.dataset.freeShippingLimit ||
              0
            );


          if (!limit) {
            return;
          }


          const limitCents =
            Math.round(
              limit * 100
            );


          const cartTotal =
            Number(
              cart.total_price ||
              0
            );


          const remaining =
            Math.max(
              limitCents -
                cartTotal,
              0
            );


          const percentage =
            Math.min(
              100,
              Math.max(
                0,
                (
                  cartTotal /
                  limitCents
                ) *
                  100
              )
            );


          const leftToSpend =
            shippingBar.querySelector(
              '[data-left-to-spend]'
            );


          const progressBar =
            shippingBar.querySelector(
              '[data-progress-bar]'
            );


          const successMessage =
            shippingBar.querySelector(
              '.free-shipping__success-message'
            );


          const defaultMessage =
            shippingBar.querySelector(
              '.free-shipping__default-message'
            );


          if (leftToSpend) {
            leftToSpend.textContent =
              formatCartMoney(
                remaining,
                cart
              );
          }


          if (progressBar) {
            progressBar.value =
              percentage;


            progressBar.setAttribute(
              'value',
              String(
                percentage
              )
            );
          }


          const qualifies =
            remaining <= 0;


          if (successMessage) {
            successMessage.style.display =
              qualifies
                ? ''
                : 'none';
          }


          if (defaultMessage) {
            defaultMessage.style.display =
              qualifies
                ? 'none'
                : '';
          }


          shippingBar.classList.toggle(
            'is-success',
            qualifies
          );


          shippingBar.classList.toggle(
            'is-qualified',
            qualifies
          );
        }
      );
    }



    /*
    ============================================================
    CART DISCOUNT HELPERS
    ============================================================

    Shopify /cart.js contains:

    original_price
    final_price
    original_line_price
    final_line_price
    discounts
    line_level_discount_allocations

    We use those values directly so discount presentation
    works immediately after quick-size ATC.
    ============================================================
    */


    function getCartItemDiscountData(
      item,
      cart
    ) {
      const originalPrice =
        Number(
          item.original_price ??
          item.price ??
          0
        );


      const finalPrice =
        Number(
          item.final_price ??
          item.price ??
          0
        );


      const originalLinePrice =
        Number(
          item.original_line_price ??
          item.line_price ??
          originalPrice
        );


      const finalLinePrice =
        Number(
          item.final_line_price ??
          item.line_price ??
          finalPrice
        );


      const discounts =
        Array.isArray(
          item.discounts
        )
          ? item.discounts
          : [];


      const allocations =
        Array.isArray(
          item.line_level_discount_allocations
        )
          ? item.line_level_discount_allocations
          : [];


      const hasDiscount =
        finalPrice <
          originalPrice ||
        finalLinePrice <
          originalLinePrice ||
        discounts.length >
          0 ||
        allocations.length >
          0;


      let savings = 0;


      if (
        allocations.length
      ) {
        savings =
          allocations.reduce(
            (
              total,
              allocation
            ) => {
              return (
                total +
                Number(
                  allocation?.amount ||
                  0
                )
              );
            },
            0
          );
      } else if (
        discounts.length
      ) {
        savings =
          discounts.reduce(
            (
              total,
              discount
            ) => {
              return (
                total +
                Number(
                  discount?.amount ||
                  0
                )
              );
            },
            0
          );
      } else {
        savings =
          Math.max(
            originalLinePrice -
              finalLinePrice,
            0
          );
      }


      let title = '';


      if (
        discounts.length &&
        discounts[0]?.title
      ) {
        title =
          discounts[0].title;
      }


      if (
        !title &&
        allocations.length &&
        allocations[0]
          ?.discount_application
          ?.title
      ) {
        title =
          allocations[0]
            .discount_application
            .title;
      }


      const priceHtml =
        hasDiscount &&
        finalPrice <
          originalPrice
          ? `
            <ins>${formatCartMoney(
              finalPrice,
              cart
            )}</ins>
            <del>${formatCartMoney(
              originalPrice,
              cart
            )}</del>
          `
          : formatCartMoney(
              finalPrice,
              cart
            );


      const discountHtml =
        hasDiscount
          ? `
            <p class="cart__discount">
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                class="icon icon-tags"
                viewBox="0 0 25 26"
              >
                <g
                  stroke="#000"
                  stroke-width=".875"
                >
                  <path d="M4.304.79h8.571l12 11.835M9.594 4.17H2.589c-.946 0-1.714.758-1.714 1.692v6.907c0 .449.18.88.502 1.196l10.47 10.329c.67.66 1.755.66 2.423 0 .173-.17.308-.376.394-.602l1.64-4.304 4.364-1.615a1.684 1.684 0 0 0 .61-2.779L10.805 4.666a1.725 1.725 0 0 0-1.211-.495Z"></path>

                  <path d="M6.018 8.82a.426.426 0 0 0-.429.423c0 .234.192.423.429.423.236 0 .428-.19.428-.423a.424.424 0 0 0-.426-.422h-.002"></path>
                </g>
              </svg>

              <span>
                You're saving ${formatCartMoney(
                  savings,
                  cart
                )}${
                  title
                    ? ` with ${escapeHTML(
                        title
                      )}`
                    : ''
                }
              </span>
            </p>
          `
          : '';


      return {
        hasDiscount,
        originalPrice,
        finalPrice,
        originalLinePrice,
        finalLinePrice,
        savings,
        title,
        priceHtml,
        discountHtml
      };
    }



    /*
    ============================================================
    ENHANCE ALREADY-RENDERED BROADCAST ITEMS
    ============================================================

    Even if Broadcast's section HTML loads without the discount
    markup, we patch the current DOM using /cart.js data.
    ============================================================
    */

    function updateRenderedCartDiscounts(
      cart
    ) {
      if (
        !cart ||
        !Array.isArray(
          cart.items
        )
      ) {
        return;
      }


      const itemsHolder =
        document.querySelector(
          '[data-items-holder]'
        );


      if (!itemsHolder) {
        return;
      }


      const renderedItems =
        Array.from(
          itemsHolder.querySelectorAll(
            '[data-item]'
          )
        );


      cart.items.forEach(
        (item) => {
          const itemKey =
            String(
              item.key ||
              ''
            );


          const renderedItem =
            renderedItems.find(
              (element) => {
                return (
                  element.getAttribute(
                    'data-item'
                  ) ===
                  itemKey
                );
              }
            );


          if (!renderedItem) {
            return;
          }


          const discountData =
            getCartItemDiscountData(
              item,
              cart
            );


          const priceElement =
            renderedItem.querySelector(
              '.cart__price'
            );


          if (priceElement) {
            priceElement.innerHTML =
              discountData.priceHtml;
          }


          const existingDiscount =
            renderedItem.querySelector(
              '.cart__discount'
            );


          if (
            discountData.hasDiscount
          ) {
            if (
              existingDiscount
            ) {
              const temp =
                document.createElement(
                  'div'
                );


              temp.innerHTML =
                discountData.discountHtml.trim();


              const replacement =
                temp.firstElementChild;


              if (replacement) {
                existingDiscount.replaceWith(
                  replacement
                );
              }
            } else {
              renderedItem.insertAdjacentHTML(
                'beforeend',
                discountData.discountHtml
              );
            }
          } else if (
            existingDiscount
          ) {
            existingDiscount.remove();
          }
        }
      );
    }



    /*
    ============================================================
    SYNC CART DRAWER FROM JSON
    ============================================================
    */

    function syncCartDrawerFromCartJson(
      cart,
      options = {}
    ) {
      if (!cart) {
        return;
      }


      const preserveRenderedItems =
        options.preserveRenderedItems ===
        true;


      updateCartCounts(
        cart
      );


      updateFreeShippingBar(
        cart
      );


      const drawer =
        document.querySelector(
          'cart-drawer#cart-drawer'
        );


      const itemsHolder =
        document.querySelector(
          '[data-items-holder]'
        );


      const totalEl =
        document.querySelector(
          '[data-cart-total]'
        );


      const drawerBody =
        document.querySelector(
          '[data-cart-drawer-body]'
        );


      const emptyDrawer =
        document.querySelector(
          '[data-cart-empty]'
        );


      const hasItems =
        Number(
          cart.item_count
        ) > 0;


      if (drawer) {
        drawer.classList.toggle(
          'is-empty',
          !hasItems
        );


        drawer.classList.add(
          'is-updated'
        );


        drawer.classList.remove(
          'is-loading'
        );


        drawer.removeAttribute(
          'inert'
        );
      }


      if (totalEl) {
        totalEl.textContent =
          hasItems
            ? formatCartMoney(
                cart.total_price,
                cart
              )
            : 'Free';


        totalEl.setAttribute(
          'data-cart-total',
          cart.total_price
        );
      }


      if (drawerBody) {
        drawerBody.style.display =
          '';


        drawerBody.style.visibility =
          'visible';


        drawerBody.style.opacity =
          '1';
      }


      if (emptyDrawer) {
        emptyDrawer.style.display =
          hasItems
            ? 'none'
            : '';


        emptyDrawer.style.visibility =
          hasItems
            ? 'hidden'
            : 'visible';


        emptyDrawer.style.opacity =
          hasItems
            ? '0'
            : '1';


        emptyDrawer.querySelectorAll(
          '[data-animation]'
        ).forEach(
          (item) => {
            item.classList.remove(
              'is-hiding'
            );


            item.classList.add(
              'is-animated',
              'aos-animate'
            );


            item.style.opacity =
              '1';


            item.style.animation =
              'none';
          }
        );
      }


      /*
      ========================================================
      BROADCAST HTML ALREADY EXISTS
      ========================================================

      Keep it, but ALWAYS enhance its prices and discount
      messages from Shopify's /cart.js response.
      */

      if (
        preserveRenderedItems
      ) {
        updateRenderedCartDiscounts(
          cart
        );


        revealCartDrawerAnimations();

        return;
      }


      if (
        !itemsHolder ||
        !Array.isArray(
          cart.items
        )
      ) {
        return;
      }


      if (!hasItems) {
        itemsHolder.innerHTML = `
          <div class="text-center">
            <p>
              Your Cart is Empty
            </p>

            <p>
              <a
                href="/"
                class="btn btn--primary btn--solid"
              >
                Continue Shopping
              </a>
            </p>
          </div>

          <div data-api-cart-price>
            <div class="cart__total">

              <span class="cart__total__label">
                Subtotal
              </span>

              <span
                class="cart__total__price cart__total__price--animated"
                data-cart-total="0"
              >
                Free
              </span>

              <div class="cart__price__loader loader">
                <div class="loader-indeterminate"></div>
              </div>

            </div>
          </div>
        `;


        revealCartDrawerAnimations();

        return;
      }



      /*
      ========================================================
      MANUAL FALLBACK CART ITEM RENDERER
      ========================================================

      This now includes Shopify's discount data.
      */

      itemsHolder.innerHTML =
        cart.items
          .map(
            (
              item,
              index
            ) => {
              const image =
                item.image ||
                item.featured_image?.url ||
                '';


              const itemUrl =
                item.url ||
                '#';


              const productTitle =
                item.product_title ||
                item.title ||
                '';


              const itemTitle =
                item.title ||
                productTitle;


              const itemKey =
                item.key ||
                item.id;


              const line =
                index + 1;


              const discountData =
                getCartItemDiscountData(
                  item,
                  cart
                );


              let optionsHtml =
                '';


              if (
                Array.isArray(
                  item.options_with_values
                )
              ) {
                optionsHtml =
                  item.options_with_values
                    .filter(
                      (
                        option
                      ) =>
                        option &&
                        option.name &&
                        option.value &&
                        option.value !==
                          'Default Title'
                    )
                    .map(
                      (
                        option
                      ) => {
                        return `
                          <p class="cart__item__selected-options">
                            <strong>
                              ${escapeHTML(
                                option.name
                              )}:
                            </strong>

                            <span>
                              ${escapeHTML(
                                option.value
                              )}
                            </span>
                          </p>
                        `;
                      }
                    )
                    .join('');
              } else if (
                item.variant_title &&
                item.variant_title !==
                  'Default Title'
              ) {
                optionsHtml = `
                  <p class="cart__item__selected-options">
                    <strong>
                      Size:
                    </strong>

                    <span>
                      ${escapeHTML(
                        item.variant_title
                      )}
                    </span>
                  </p>
                `;
              }


              return `
                <div
                  class="cart__item${
                    index ===
                    cart.items.length -
                      1
                      ? ' cart__item--no-border'
                      : ''
                  }"
                  data-item="${escapeHTML(
                    itemKey
                  )}"
                  data-item-index="${line}"
                  data-item-title="${escapeHTML(
                    itemTitle
                  )}"
                  data-animation="cart-items-fade"
                  data-animation-duration="500"
                  data-animation-delay="${
                    index * 50
                  }"
                >

                  <div class="cart__item__image">

                    <a
                      href="${escapeHTML(
                        itemUrl
                      )}"
                      aria-label="${escapeHTML(
                        itemTitle
                      )}"
                    >

                      ${
                        image
                          ? `
                        <div class="lazy-image">

                          <img
                            src="${escapeHTML(
                              image
                            )}"
                            alt="${escapeHTML(
                              itemTitle
                            )}"
                            width="180"
                            loading="lazy"
                            sizes="90px"
                          >

                        </div>
                      `
                          : ''
                      }

                    </a>

                  </div>


                  <div class="cart__item__content">

                    <div class="cart__item__content-inner">

                      <h4 class="cart__item__title">

                        <a
                          href="${escapeHTML(
                            itemUrl
                          )}"
                        >
                          ${escapeHTML(
                            productTitle
                          )}
                        </a>

                      </h4>


                      <div class="cart__item__meta">

                        ${optionsHtml}

                      </div>

                    </div>


                    <p class="cart__price">

                      ${discountData.priceHtml}

                    </p>


                    <quantity-counter class="cart__quantity-counter">

                      <div class="cart__quantity">

                        <button
                          class="cart__quantity-minus"
                          type="button"
                          name="decrease"
                          title="Decrease button quantity - ${escapeHTML(
                            itemTitle
                          )}"
                        >

                          <svg
                            aria-hidden="true"
                            focusable="false"
                            role="presentation"
                            class="icon icon-minus"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M6 12h12"
                              stroke="#000"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>

                        </button>


                        <input
                          class="cart__quantity-field"
                          type="number"
                          id="updates_${escapeHTML(
                            itemKey
                          )}"
                          name="updates[]"
                          data-id="${escapeHTML(
                            itemKey
                          )}"
                          value="${
                            item.quantity
                          }"
                          title="Quantity field - ${escapeHTML(
                            itemTitle
                          )}"
                          pattern="[0-9]*"
                        >


                        <button
                          class="cart__quantity-plus"
                          type="button"
                          name="increase"
                          title="Increase button quantity - ${escapeHTML(
                            itemTitle
                          )}"
                        >

                          <svg
                            aria-hidden="true"
                            focusable="false"
                            role="presentation"
                            class="icon icon-plus"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M6 12h6m6 0h-6m0 0V6m0 6v6"
                              stroke="#000"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>

                        </button>

                      </div>


                      <a
                        class="cart__item__remove"
                        href="/cart/change?line=${line}&quantity=0"
                        data-item-remove
                        data-id="${escapeHTML(
                          itemKey
                        )}"
                        title="Remove"
                      >
                        Remove
                      </a>

                    </quantity-counter>

                  </div>


                  ${discountData.discountHtml}

                </div>
              `;
            }
          )
          .join('');


      /*
      One more pass to guarantee the DOM matches Shopify's
      current /cart.js discount information.
      */

      updateRenderedCartDiscounts(
        cart
      );


      revealCartDrawerAnimations();
    }



    /*
    ============================================================
    BROADCAST CART SECTION REFRESH
    ============================================================
    */

    function replaceCartDrawerSection(
      sectionHtml
    ) {
      if (!sectionHtml) {
        return false;
      }


      const parser =
        new DOMParser();


      const doc =
        parser.parseFromString(
          sectionHtml,
          'text/html'
        );


      const newDrawer =
        doc.querySelector(
          'cart-drawer#cart-drawer'
        );


      const currentDrawer =
        document.querySelector(
          'cart-drawer#cart-drawer'
        );


      if (
        newDrawer &&
        currentDrawer
      ) {
        currentDrawer.innerHTML =
          newDrawer.innerHTML;


        return true;
      }


      const newBody =
        doc.querySelector(
          '[data-cart-drawer-body]'
        );


      const currentBody =
        document.querySelector(
          '[data-cart-drawer-body]'
        );


      if (
        newBody &&
        currentBody
      ) {
        currentBody.innerHTML =
          newBody.innerHTML;
      }


      const newEmpty =
        doc.querySelector(
          '[data-cart-empty]'
        );


      const currentEmpty =
        document.querySelector(
          '[data-cart-empty]'
        );


      if (
        newEmpty &&
        currentEmpty
      ) {
        currentEmpty.innerHTML =
          newEmpty.innerHTML;


        currentEmpty.setAttribute(
          'style',
          newEmpty.getAttribute(
            'style'
          ) || ''
        );
      }


      return !!(
        newBody &&
        currentBody
      );
    }



    async function fetchCartDrawerSectionHtml() {
      const sectionId =
        getCartDrawerSectionId();


      const timestamp =
        Date.now();


      /*
      First attempt:
      Shopify Section Rendering API.
      */

      if (sectionId) {
        try {
          const response =
            await fetch(
              `/cart?sections=${encodeURIComponent(
                sectionId
              )}&_=${timestamp}`,
              {
                headers: {
                  Accept:
                    'application/json'
                },

                cache:
                  'no-store'
              }
            );


          if (response.ok) {
            const sections =
              await response.json();


            if (
              sections &&
              sections[
                sectionId
              ]
            ) {
              return sections[
                sectionId
              ];
            }
          }
        } catch (error) {
          console.warn(
            'Cart section JSON refresh failed:',
            error
          );
        }


        /*
        Second attempt:
        section_id HTML endpoint.
        */

        try {
          const response =
            await fetch(
              `/cart?section_id=${encodeURIComponent(
                sectionId
              )}&_=${timestamp}`,
              {
                headers: {
                  Accept:
                    'text/html'
                },

                cache:
                  'no-store'
              }
            );


          if (response.ok) {
            const html =
              await response.text();


            if (html) {
              return html;
            }
          }
        } catch (error) {
          console.warn(
            'Cart section HTML refresh failed:',
            error
          );
        }
      }


      /*
      Final fallback:
      Full cart HTML.
      */

      try {
        const response =
          await fetch(
            `/cart?_=${timestamp}`,
            {
              headers: {
                Accept:
                  'text/html'
              },

              cache:
                'no-store'
            }
          );


        if (!response.ok) {
          return null;
        }


        const html =
          await response.text();


        const parser =
          new DOMParser();


        const doc =
          parser.parseFromString(
            html,
            'text/html'
          );


        const drawer =
          doc.querySelector(
            'cart-drawer#cart-drawer'
          );


        if (drawer) {
          return drawer.outerHTML;
        }


        return html;
      } catch (error) {
        console.error(
          'Full cart page refresh failed:',
          error
        );


        return null;
      }
    }



    async function refreshCartDrawerSection() {
      const sectionHtml =
        await fetchCartDrawerSectionHtml();


      if (!sectionHtml) {
        return false;
      }


      return replaceCartDrawerSection(
        sectionHtml
      );
    }



    /*
    ============================================================
    FETCH CURRENT SHOPIFY CART
    ============================================================
    */

    async function getCurrentCartJson() {
      try {
        const response =
          await fetch(
            `/cart.js?_=${Date.now()}`,
            {
              headers: {
                Accept:
                  'application/json'
              },

              cache:
                'no-store'
            }
          );


        if (!response.ok) {
          return null;
        }


        return await response.json();
      } catch (error) {
        console.error(
          'Unable to fetch cart JSON:',
          error
        );


        return null;
      }
    }



    /*
    ============================================================
    OPEN CART DRAWER
    ============================================================
    */

    function openCartDrawer(
      cart,
      options = {}
    ) {
      const drawer =
        document.querySelector(
          'cart-drawer#cart-drawer'
        );


      if (drawer) {
        drawer.classList.add(
          'is-open'
        );


        drawer.setAttribute(
          'open',
          ''
        );


        drawer.removeAttribute(
          'inert'
        );


        const inner =
          drawer.querySelector(
            '[data-cart-drawer-inner]'
          );


        if (inner) {
          inner.removeAttribute(
            'inert'
          );
        }


        window.requestAnimationFrame(
          () => {
            drawer.focus();

            revealCartDrawerAnimations();
          }
        );
      }


      document.documentElement.classList.add(
        'js-drawer-open'
      );


      document.body.classList.add(
        'js-drawer-open'
      );


      /*
      Lock page/body scrolling.

      Cart drawer's own internal scrolling remains active.
      */

      window.dispatchEvent(
        new CustomEvent(
          'theme:scroll:lock',
          {
            detail: 0,
            bubbles: true
          }
        )
      );


      syncCartDrawerFromCartJson(
        cart,
        options
      );


      /*
      Guarantee discount markup AFTER all cart DOM updates.
      */

      updateRenderedCartDiscounts(
        cart
      );


      revealCartDrawerAnimations();


      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            detail: {
              cart
            }
          }
        )
      );


      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            detail: {
              cart
            }
          }
        )
      );


      document.dispatchEvent(
        new CustomEvent(
          'cart:open',
          {
            detail: {
              cart
            }
          }
        )
      );


      document.dispatchEvent(
        new CustomEvent(
          'theme:cart:open',
          {
            detail: {
              cart
            }
          }
        )
      );


      document.dispatchEvent(
        new CustomEvent(
          'drawer:open',
          {
            detail: {
              id:
                'cart-drawer',

              cart
            }
          }
        )
      );


      /*
      Some Broadcast event listeners may touch cart markup
      after our event dispatch.

      Re-run only the discount DOM enhancement afterwards.
      */

      window.requestAnimationFrame(
        () => {
          updateRenderedCartDiscounts(
            cart
          );


          revealCartDrawerAnimations();
        }
      );


      window.setTimeout(
        () => {
          updateRenderedCartDiscounts(
            cart
          );


          revealCartDrawerAnimations();
        },
        50
      );


      window.setTimeout(
        () => {
          updateRenderedCartDiscounts(
            cart
          );


          revealCartDrawerAnimations();
        },
        250
      );
    }



    /*
    ============================================================
    UPDATE QUANTITY / REMOVE ITEM
    ============================================================
    */

    async function updateCartLineItemFromDrawer(
      line,
      quantity,
      item
    ) {
      if (
        !line &&
        line !== 0
      ) {
        return;
      }


      const drawer =
        document.querySelector(
          'cart-drawer#cart-drawer'
        );


      if (drawer) {
        drawer.classList.add(
          'is-loading'
        );
      }


      if (item) {
        item.classList.add(
          Number(quantity) > 0
            ? 'is-loading'
            : 'is-removed'
        );
      }


      try {
        const response =
          await fetch(
            '/cart/change.js',
            {
              method:
                'POST',

              headers: {
                'Content-Type':
                  'application/json',

                Accept:
                  'application/json'
              },

              body:
                JSON.stringify(
                  {
                    line:
                      Number(
                        line
                      ),

                    quantity:
                      Number(
                        quantity
                      )
                  }
                )
            }
          );


        if (!response.ok) {
          throw new Error(
            'Unable to update cart item'
          );
        }


        /*
        /cart/change.js already returns cart JSON, but fetch
        /cart.js again so we definitely receive the latest
        discount allocations.
        */

        let cart =
          await response.json();


        const freshCart =
          await getCurrentCartJson();


        if (freshCart) {
          cart =
            freshCart;
        }


        const sectionRefreshed =
          await refreshCartDrawerSection();


        syncCartDrawerFromCartJson(
          cart,
          {
            preserveRenderedItems:
              sectionRefreshed
          }
        );


        openCartDrawer(
          cart,
          {
            preserveRenderedItems:
              sectionRefreshed
          }
        );


        updateRenderedCartDiscounts(
          cart
        );


        revealCartDrawerAnimations();
      } catch (error) {
        console.error(
          error
        );
      } finally {
        if (drawer) {
          drawer.classList.remove(
            'is-loading'
          );
        }


        if (item) {
          item.classList.remove(
            'is-loading',
            'is-removed'
          );
        }
      }
    }



    /*
    ============================================================
    CART DRAWER EVENTS
    ============================================================
    */

    function initNewStyledCartDrawerEvents() {
      if (
        document.documentElement.dataset.newStyledCartDrawerEventsBound ===
        'true'
      ) {
        return;
      }


      document.documentElement.dataset.newStyledCartDrawerEventsBound =
        'true';



      function getLineFromItem(
        item
      ) {
        if (!item) {
          return null;
        }


        const line =
          item.getAttribute(
            'data-item-index'
          );


        return line
          ? Number(line)
          : null;
      }



      function unlockCartDrawerClicks() {
        const drawer =
          document.querySelector(
            'cart-drawer#cart-drawer'
          );


        if (!drawer) {
          return;
        }


        drawer.removeAttribute(
          'inert'
        );


        const inner =
          drawer.querySelector(
            '[data-cart-drawer-inner]'
          );


        if (inner) {
          inner.removeAttribute(
            'inert'
          );
        }
      }



      function closeCartDrawer() {
        const drawer =
          document.querySelector(
            'cart-drawer#cart-drawer'
          );


        if (drawer) {
          drawer.classList.remove(
            'is-open'
          );


          drawer.removeAttribute(
            'open'
          );


          drawer.removeAttribute(
            'inert'
          );


          const inner =
            drawer.querySelector(
              '[data-cart-drawer-inner]'
            );


          if (inner) {
            inner.removeAttribute(
              'inert'
            );
          }
        }


        document.documentElement.classList.remove(
          'js-drawer-open'
        );


        document.body.classList.remove(
          'js-drawer-open'
        );


        window.dispatchEvent(
          new CustomEvent(
            'theme:scroll:unlock',
            {
              detail: 0,
              bubbles: true
            }
          )
        );


        document.dispatchEvent(
          new CustomEvent(
            'drawer:close',
            {
              detail: {
                id:
                  'cart-drawer'
              }
            }
          )
        );


        document.dispatchEvent(
          new CustomEvent(
            'theme:cart:close',
            {
              detail: {
                id:
                  'cart-drawer'
              }
            }
          )
        );
      }



      document.addEventListener(
        'click',
        async function(event) {
          const cartDrawer =
            event.target.closest(
              'cart-drawer#cart-drawer'
            );


          if (cartDrawer) {
            unlockCartDrawerClicks();
          }


          const drawerUnderlay =
            event.target.closest(
              'cart-drawer [data-drawer-underlay]'
            );


          const drawerClose =
            event.target.closest(
              'cart-drawer [data-cart-drawer-close]'
            );


          if (
            drawerUnderlay ||
            drawerClose
          ) {
            event.preventDefault();

            event.stopPropagation();


            if (
              event.stopImmediatePropagation
            ) {
              event.stopImmediatePropagation();
            }


            closeCartDrawer();

            return;
          }


          const removeButton =
            event.target.closest(
              'cart-drawer [data-item-remove]'
            );


          const quantityButton =
            event.target.closest(
              'cart-drawer .cart__quantity-minus, cart-drawer .cart__quantity-plus'
            );


          if (removeButton) {
            event.preventDefault();

            event.stopPropagation();


            if (
              event.stopImmediatePropagation
            ) {
              event.stopImmediatePropagation();
            }


            unlockCartDrawerClicks();


            const item =
              removeButton.closest(
                '[data-item]'
              );


            const line =
              getLineFromItem(
                item
              );


            if (!line) {
              return;
            }


            removeButton.classList.add(
              'is-loading'
            );


            await updateCartLineItemFromDrawer(
              line,
              0,
              item
            );


            removeButton.classList.remove(
              'is-loading'
            );


            return;
          }


          if (quantityButton) {
            event.preventDefault();

            event.stopPropagation();


            if (
              event.stopImmediatePropagation
            ) {
              event.stopImmediatePropagation();
            }


            unlockCartDrawerClicks();


            const counter =
              quantityButton.closest(
                'quantity-counter'
              );


            const item =
              quantityButton.closest(
                '[data-item]'
              );


            const input =
              counter
                ? counter.querySelector(
                    'input[name="updates[]"]'
                  )
                : null;


            const line =
              getLineFromItem(
                item
              );


            if (
              !input ||
              !line
            ) {
              return;
            }


            const previousValue =
              input.value;


            if (
              quantityButton.name ===
              'increase'
            ) {
              input.stepUp();
            }


            if (
              quantityButton.name ===
              'decrease'
            ) {
              input.stepDown();
            }


            if (
              previousValue !==
              input.value
            ) {
              await updateCartLineItemFromDrawer(
                line,
                input.value,
                item
              );
            }


            return;
          }
        },
        true
      );



      document.addEventListener(
        'change',
        async function(event) {
          const input =
            event.target.closest(
              'cart-drawer input[name="updates[]"]'
            );


          if (!input) {
            return;
          }


          event.preventDefault();

          event.stopPropagation();


          if (
            event.stopImmediatePropagation
          ) {
            event.stopImmediatePropagation();
          }


          unlockCartDrawerClicks();


          const item =
            input.closest(
              '[data-item]'
            );


          const line =
            getLineFromItem(
              item
            );


          if (!line) {
            return;
          }


          await updateCartLineItemFromDrawer(
            line,
            input.value,
            item
          );
        },
        true
      );



      document.addEventListener(
        'theme:cart:update',
        async function(event) {
          const item =
            event.target.closest(
              'cart-drawer [data-item]'
            );


          if (!item) {
            return;
          }


          event.preventDefault();

          event.stopPropagation();


          if (
            event.stopImmediatePropagation
          ) {
            event.stopImmediatePropagation();
          }


          unlockCartDrawerClicks();


          const line =
            getLineFromItem(
              item
            );


          const quantity =
            event.detail
              ? event.detail.quantity
              : null;


          if (
            !line ||
            quantity === null
          ) {
            return;
          }


          await updateCartLineItemFromDrawer(
            line,
            quantity,
            item
          );
        },
        true
      );



      document.addEventListener(
        'cart:open',
        function() {
          unlockCartDrawerClicks();
        },
        true
      );



      document.addEventListener(
        'theme:cart:open',
        function() {
          unlockCartDrawerClicks();
        },
        true
      );



      document.addEventListener(
        'drawer:open',
        function(event) {
          if (
            event.detail &&
            event.detail.id ===
              'cart-drawer'
          ) {
            unlockCartDrawerClicks();
          }
        },
        true
      );
    }



    /*
    ============================================================
    QUICK SIZE ADD TO CART
    ============================================================
    */

    function initNewStyledATC() {
      if (
        document.documentElement.dataset.newStyledAtcBound ===
        'true'
      ) {
        return;
      }


      document.documentElement.dataset.newStyledAtcBound =
        'true';



      document.addEventListener(
        'click',
        async function(event) {
          const toggle =
            event.target.closest(
              '[data-new-styled-atc-toggle]'
            );


          const close =
            event.target.closest(
              '[data-new-styled-atc-close]'
            );


          const sizeButton =
            event.target.closest(
              '[data-new-styled-atc-size]'
            );


          const activeAtc =
            event.target.closest(
              '[data-new-styled-atc]'
            );



          /*
          OPEN SIZE PICKER
          */

          if (toggle) {
            event.preventDefault();

            event.stopPropagation();


            const atc =
              toggle.closest(
                '[data-new-styled-atc]'
              );


            if (!atc) {
              return;
            }


            document.querySelectorAll(
              '[data-new-styled-atc].is-open'
            ).forEach(
              (item) => {
                if (
                  item !== atc
                ) {
                  item.classList.remove(
                    'is-open'
                  );
                }
              }
            );


            atc.classList.add(
              'is-open'
            );


            return;
          }



          /*
          CLOSE SIZE PICKER
          */

          if (close) {
            event.preventDefault();

            event.stopPropagation();


            const atc =
              close.closest(
                '[data-new-styled-atc]'
              );


            if (atc) {
              atc.classList.remove(
                'is-open'
              );
            }


            return;
          }



          /*
          ADD SELECTED SIZE
          */

          if (sizeButton) {
            event.preventDefault();

            event.stopPropagation();


            if (
              event.stopImmediatePropagation
            ) {
              event.stopImmediatePropagation();
            }


            if (
              sizeButton.disabled ||
              sizeButton.classList.contains(
                'is-disabled'
              )
            ) {
              return;
            }


            const variantId =
              sizeButton.dataset.variantId;


            const atc =
              sizeButton.closest(
                '[data-new-styled-atc]'
              );


            if (
              !variantId ||
              !atc
            ) {
              return;
            }


            sizeButton.classList.add(
              'is-loading'
            );


            atc.classList.add(
              'is-adding'
            );


            atc.querySelectorAll(
              '[data-new-styled-atc-size]'
            ).forEach(
              (button) => {
                button.disabled =
                  true;
              }
            );


            try {
              /*
              Add product.
              */

              const addResponse =
                await fetch(
                  '/cart/add.js',
                  {
                    method:
                      'POST',

                    headers: {
                      'Content-Type':
                        'application/json',

                      Accept:
                        'application/json'
                    },

                    body:
                      JSON.stringify(
                        {
                          id:
                            Number(
                              variantId
                            ),

                          quantity:
                            1
                        }
                      )
                  }
                );


              if (!addResponse.ok) {
                throw new Error(
                  'Unable to add item to cart'
                );
              }


              /*
              IMPORTANT:

              Fetch /cart.js AFTER the add.

              This response contains the automatic discount
              allocations immediately, which we confirmed.
              */

              const cart =
                await getCurrentCartJson();


              if (!cart) {
                throw new Error(
                  'Unable to retrieve updated cart'
                );
              }


              atc.classList.remove(
                'is-open'
              );


              /*
              Attempt Broadcast section refresh.
              */

              const sectionRefreshed =
                await refreshCartDrawerSection();


              /*
              Sync cart.

              Regardless of whether Broadcast returned proper
              discount HTML, syncCartDrawerFromCartJson()
              will patch each rendered item using /cart.js.
              */

              syncCartDrawerFromCartJson(
                cart,
                {
                  preserveRenderedItems:
                    sectionRefreshed
                }
              );


              /*
              Apply discounts BEFORE opening.
              */

              updateRenderedCartDiscounts(
                cart
              );


              /*
              Open cart.
              */

              window.requestAnimationFrame(
                () => {
                  openCartDrawer(
                    cart,
                    {
                      preserveRenderedItems:
                        sectionRefreshed
                    }
                  );
                }
              );
            } catch (error) {
              console.error(
                error
              );
            } finally {
              sizeButton.classList.remove(
                'is-loading'
              );


              if (atc) {
                atc.querySelectorAll(
                  '[data-new-styled-atc-size]'
                ).forEach(
                  (button) => {
                    if (
                      !button.classList.contains(
                        'is-disabled'
                      )
                    ) {
                      button.disabled =
                        false;
                    }
                  }
                );


                window.setTimeout(
                  () => {
                    atc.classList.remove(
                      'is-adding'
                    );
                  },
                  250
                );
              }
            }


            return;
          }



          /*
          CLICK OUTSIDE SIZE PICKER
          */

          if (!activeAtc) {
            document.querySelectorAll(
              '[data-new-styled-atc].is-open'
            ).forEach(
              (item) => {
                item.classList.remove(
                  'is-open'
                );
              }
            );
          }
        },
        true
      );
    }



    /*
    ============================================================
    INITIALIZATION
    ============================================================
    */

    function initCustomProductCards(
      root
    ) {
      const scope =
        root || document;


      initMobileCardCarousels(
        scope
      );


      scope.querySelectorAll(
        '[data-grid-item]'
      ).forEach(
        normalizeLinkedSwatches
      );


      initCarouselLinkedSwatches(
        scope
      );


      initNewStyledATC();


      initNewStyledCartDrawerEvents();
    }



    /*
    ============================================================
    COLLECTION GRID OBSERVER
    ============================================================
    */

    function observeCollectionProductGrids(
      root
    ) {
      const scope =
        root || document;


      const grids =
        scope.querySelectorAll(
          '[data-products-grid], #CollectionLoop'
        );


      grids.forEach(
        (grid) => {
          if (
            grid.dataset.customProductCardsObserverBound ===
            'true'
          ) {
            return;
          }


          grid.dataset.customProductCardsObserverBound =
            'true';


          const observer =
            new MutationObserver(
              (
                mutations
              ) => {
                let shouldInit =
                  false;


                mutations.forEach(
                  (
                    mutation
                  ) => {
                    if (
                      mutation.addedNodes &&
                      mutation.addedNodes.length
                    ) {
                      shouldInit =
                        true;
                    }
                  }
                );


                if (!shouldInit) {
                  return;
                }


                window.requestAnimationFrame(
                  () => {
                    initCustomProductCards(
                      grid
                    );
                  }
                );
              }
            );


          observer.observe(
            grid,
            {
              childList:
                true,

              subtree:
                true
            }
          );
        }
      );
    }



    /*
    ============================================================
    PAGE LOAD
    ============================================================
    */

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initCustomProductCards(
          document
        );


        observeCollectionProductGrids(
          document
        );
      }
    );



    /*
    ============================================================
    SHOPIFY THEME EDITOR SECTION LOAD
    ============================================================
    */

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initCustomProductCards(
          event.target
        );


        observeCollectionProductGrids(
          event.target
        );
      }
    );

  })();


  // Keep scripts inside this IIFE to avoid leaking variables
  // into the global scope.

})();